import { Link } from "react-router-dom";
import SectionHeader from "@/components/base/SectionHeader";

const categories = [
  {
    title: "Infrastructure & Network",
    icon: "ri-server-line",
    technologies: ["LAN/WAN", "Windows Server", "VMware/vCenter", "Virtualization", "Infrastructure Modernization"],
  },
  {
    title: "Database & Data",
    icon: "ri-database-2-line",
    technologies: ["Oracle", "SQL Server", "Database Administration", "Schema Management", "Reporting"],
  },
  {
    title: "Application Engineering",
    icon: "ri-code-s-slash-line",
    technologies: ["C#", ".NET/ASP.NET", "JavaScript", "Angular", "WebSphere"],
  },
  {
    title: "Microsoft Platforms",
    icon: "ri-window-line",
    technologies: ["Power Apps", "Power Automate", "Power BI", "SharePoint", "Nintex"],
  },
  {
    title: "Cloud & DevOps",
    icon: "ri-cloud-line",
    technologies: ["Microsoft Azure", "Azure IaaS", "Azure PaaS", "Azure DevOps", "Hybrid Cloud"],
  },
  {
    title: "Web, Mobile & AI",
    icon: "ri-global-line",
    technologies: ["HTML/CSS", "CMS", "Web Portals", "Mobile Applications", "AI-Assisted Engineering"],
  },
];

export default function TechnologyExpertiseSection() {
  return (
    <section className="section-padding bg-background-100">
      <div className="container-page">
        <SectionHeader
          title="Technology Expertise"
          subtitle="Platforms & Tools"
          description="Technology experience across enterprise infrastructure, databases, platforms, cloud, and development environments."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((category) => (
            <div
              key={category.title}
              className="card-base p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                  <i className={`${category.icon} text-primary-600 text-lg`} aria-hidden="true"></i>
                </div>
                <h3 className="text-base font-bold text-foreground-900">
                  {category.title}
                </h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {category.technologies.map((tech) => (
                  <span
                    key={tech}
                    className="inline-flex items-center px-3 py-1.5 rounded-md bg-secondary-100 text-secondary-900 text-sm font-medium"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link to="/technologies" className="btn-primary">
            View All Technologies
            <i className="ri-arrow-right-line ml-2" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}